<template>
    <section class="main" v-loading="isLoading">
        <plat-form-component @updateData="updateData" :option="{dateRadio: true}"></plat-form-component>
        <section class="operate">
            <title-date-component :titleOption="titleOption"></title-date-component>
            <section class="indicators-data-box">
                <indicators-data-component v-for="(item, index) in indicatorsData" :data="item" :key="index"></indicators-data-component>
            </section>
        </section>
        <section class="box">
            <section class="analysis">
                <transaction-component :resultData="resultData"></transaction-component>
            </section>
            <section class="analysis">
                <product-analysis-component :resultData="resultData"></product-analysis-component>
            </section>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    * {
        margin: 0;
        padding: 0;
    }
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 0;
    }
    .title-date {
        margin-top: 10px;
        padding: 0 20px;
    }
    .operate {
        width: 98%;
        background-color: #FFF;
        border-radius: 3px;
        overflow: hidden;
        margin-top: 60px;
        margin-left: 1%;
        .indicators-data-box {
            width: 100%;
            padding: 25px 20px;
        }
    }
    .box {
        width: 98%;
        height: 350px;
        margin-top: 20px;
        margin-left: 1%;
        .analysis {
            width: 50%;
            height: 100%;
            background-color: #FFF;
            border-radius: 3px;
            float: left;
            overflow: hidden;
            &:nth-child(1) {
                border-right: 10px solid #F7F9FA;
            }
            &:nth-child(2) {
                border-left: 10px solid #F7F9FA;
            }
        }
    }
</style>

<script>
    import PlatFormComponent from '../components/PlatForm.vue'
    import TitleDateComponent from '../../components/title-date/TitleDate.vue'
    import IndicatorsDataComponent from '../../components/indicators-data/IndicatorsData.vue'
    import TransactionComponent from './components/transaction/Transaction.vue'
    import ProductAnalysisComponent from './components/productAnalysis/ProductAnalysis.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import MomentFormat from '../../filters/moment-format'

    export default {
        components: {
            PlatFormComponent,
            TitleDateComponent,
            IndicatorsDataComponent,
            TransactionComponent,
            ProductAnalysisComponent
        },
        data () {
            const data = {
                titleOption: {
                    title: '经营概况',
                    more: true,
                    moreUrl: 'menpiaoOperateData'
                },
                resultData: {},
                salePlatform: 0, // 平台
                date: {
                    startDate: MomentFormat.getYestoday(), // 默认昨天
                    endDate: MomentFormat.getYestoday()
                },
                compareInfo: '较上周同期',
                isLoading: false
            }
            return data;
        },
        computed: {
            indicatorsData () {
                return {
                    payAmount: {
                        name: '销售额',
                        value: this.resultData.payAmount,
                        unit: '元',
                        compare: this.resultData.payAmountPercent,
                        title: '销售额',
                        compareInfo: this.compareInfo
                    },
                    payQuantity: {
                        name: '销售量',
                        value: this.resultData.payQuantity,
                        unit: '件',
                        compare: this.resultData.payQuantityPercent,
                        title: '销量',
                        compareInfo: this.compareInfo
                    },
                    consumeOrderNum: {
                        name: '消费券量',
                        value: this.resultData.consumeQuantity,
                        unit: '件',
                        compare: this.resultData.consumeQuantityPercent,
                        title: '验证的券量',
                        compareInfo: this.compareInfo
                    },
                    visitPurchaseRate: {
                        name: '访购率',
                        value: this.resultData.visitPurchaseRate,
                        unit: '%',
                        compare: this.resultData.visitPurchaseRatePercent,
                        title: '支付用户数/浏览用户数',
                        compareInfo: this.compareInfo
                    },
                    refundRate: {
                        name: '退款率',
                        value: this.resultData.refundRate,
                        unit: '%',
                        compare: this.resultData.refundRatePercent,
                        title: '用户申请退款的订单数/支付订单数',
                        compareInfo: this.compareInfo
                    }
                }
            }
        },
        methods: {
            // 获取数据
            getData () {
                this.isLoading = true;
                menpiaoDataPlatform.getIndexData(this.salePlatform, this.date.startDate, this.date.endDate, false)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.resultData = res.data.sum === null ? {} : res.data.sum;
                            this.resultData.compareInfo = this.compareInfo;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 更新数据
            updateData (params) {
                this.salePlatform = params.salePlatform;
                this.date.startDate = params.dateRange.startDate;
                this.date.endDate = params.dateRange.endDate;
                if (params.dateRadio === 0) {
                    this.compareInfo = '较上周同期';
                } else if (params.dateRadio === 1) {
                    this.compareInfo = '较上周整体';
                } else if (params.dateRadio === 2) {
                    this.compareInfo = '环比上月';
                } else {
                    this.compareInfo = '较上一周期';
                }
                this.getData();
            }
        },
        created () {
            this.getData();
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?1fcac49a